import { Box } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'
import AdxInput from 'components/custom/AdxInput'
import React, { useEffect, useState } from 'react'

const ClaimRejectForm = ({ mutateApprove, approveIsLoading, handleRejectClose }) => {
  const [feedback, setFeedback] = useState('')
  const [values, setValues] = useState('')
  const [buttonDisabled, setButtonDisabled] = useState(true)

  useEffect(() => {
    if (feedback === '') {
      setButtonDisabled(true)
    } else {
      setButtonDisabled(false)
      setValues({
        action: 0,
        feedback: feedback,
      })
    }
  }, [feedback])

  return (
    <Box>
      <AdxInput
        label="State reason"
        multiline
        minRows={2}
        sxInput={{ padding: 2 }}
        charLimit={120}
        onChange={(e) => setFeedback(e.target.value)}
      />
      <Box my={2} display="flex" alignItems="center" justifyContent="center" columnGap={2}>
        <AdxButton variant={'ghost'} onClick={handleRejectClose}>
          Cancel
        </AdxButton>
        <AdxButton
          variant={'contained'}
          color="error"
          sx={{
            width: 200,
            '&:hover': {
              backgroundColor: 'error.main',
            },
          }}
          disabled={buttonDisabled || approveIsLoading}
          isLoading={approveIsLoading}
          onClick={() => mutateApprove(values)}
        >
          Reject
        </AdxButton>
      </Box>
    </Box>
  )
}

export default ClaimRejectForm
